import React, { useReducer } from 'react';
import { useDropzone } from 'react-dropzone';
import ProgressBar from 'react-bootstrap/ProgressBar';

const initialState = {
  status: 'idle',
  fileName: '',
};

const actionfile = {
  LOADING: 'loading',
  SUCCESS: 'success',
  ERROR: 'error',
  RESET: 'reset', // Nueva acción para limpiar el estado
};

function reducer(state, action) {
  switch (action.type) {
    case actionfile.LOADING:
      return { ...state, status: 'loading', fileName: action.payload };
    case actionfile.SUCCESS:
      return { ...state, status: 'success' };
    case actionfile.ERROR:
      return { ...state, status: 'error' };
    case actionfile.RESET: // Manejamos la acción de reset
      return initialState;
    default:
      return state;
  }
}

const FileUpload = ({ onFileChange }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  const onDrop = (acceptedFiles) => {
    const file = acceptedFiles[0];

    if (file) {
      const allowedExtensions = ['.pdf', '.docx'];
      const fileExtension = file.name.slice(file.name.lastIndexOf('.')).toLowerCase();

      if (!allowedExtensions.includes(fileExtension)) {
        dispatch({ type: actionfile.ERROR });
        return;
      }

      onFileChange(file);
      dispatch({ type: actionfile.LOADING, payload: file.name });
    }
  };

  // Función para eliminar el archivo subido
  const onRemoveFile = () => {
    dispatch({ type: actionfile.RESET });
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: {
      'application/pdf': [],
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document': [],
    },
    multiple: false,
  });

  return (
    <div className="row mt-24">
      {state.status === 'idle' && (
        <div className="col-12 mt-16">
          <div {...getRootProps()}>
            {isDragActive ? (
              <div className="upload-hov">
              <div className="row">
                <div className="col-12">
                  <div className="-icon">
                    <i className="fa-solid fa-file-arrow-up"></i>
                  </div>
                </div>
                <div className="col-12 mt-16">
                  <p className="body-1 text-c">
                    Arrastra hasta aquí el documento que deseas subir
                  </p>
                  <p className="caption text-c">
                    Puedes subir archivos PDF, DOCX.
                  </p>
                </div>
              </div>
            </div>
            ) : (
              <div className="upload">
                <div className="row">
                  <div className="col-12">
                    <div className="-icon">
                      <i className="fa-solid fa-file-arrow-up"></i>
                    </div>
                  </div>
                  <div className="col-12 mt-16">
                    <p className="body-1 text-c">
                      Arrastra hasta aquí el documento que deseas subir
                    </p>
                    <p className="caption text-c">
                      Puedes subir archivos PDF, DOCX.
                    </p>
                  </div>
                </div>
                <div className="row mt-32 justify-content-center">
                  <div className="col-12 col-md-8 col-lg-6">
                    <label className="btn -primary">Escoge documento</label>
                  </div>
                </div>
              </div>
            )}
          </div>
          <input {...getInputProps()} className="d-none" />
        </div>
      )}

      {(state.status === 'loading' || state.status === 'success') && (
        <div className="col-12">
          <div className="card -white p-16">
            <div className="row">
              <span className="col-12 d-flex justify-content-between">
                <span className="body-2 -raspberry">
                  <i className="fa-solid fa-file-arrow-up"></i> <span className="ml-8">{state.fileName}</span>
                </span>
                <button className="btn -icon -danger" onClick={onRemoveFile}>
                  <i className="fa-solid fa-trash"></i>
                </button>
              </span>
            </div>
            <div className="row">
              <div className="col-12 mt-16">
                <ProgressBar now={100} />
              </div>
            </div>
          </div>
        </div>
      )}

      {state.status === 'error' && (
        <div className="col-12">
          <div className="card -white p-16">
            <div className="row">
              <span className="col-12 d-flex justify-content-between">
                <span className="body-2 -raspberry">
                  <i className="fa-solid fa-file-exclamation"></i> <span className="ml-8">Formato no permitido</span>
                </span>
                <button className="btn -icon -danger" onClick={onRemoveFile}>
                  <i className="fa-solid fa-trash"></i>
                </button>
              </span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default FileUpload;
